import { ArgumentNullException } from '../Exceptions';
export default function expire(...predicates) {
    if (predicates.length === 0) {
        throw new ArgumentNullException("predicates");
    }
    else {
        let isExpired = false;
        const delegate = (value) => {
            return isExpired || (isExpired = predicates.some(p => p(value)));
        };
        return delegate;
    }
}
expire.when = expire;
expire.at = expireAt;
expire.in = expireIn;
expire.now = expire(() => true);
expire.never = expire(() => false);
expire.tomorrow = expireTomorrow;
expire.inSeconds = expireInSeconds;
expire.inMinutes = expireInMinutes;
expire.inHours = expireInHours;
expire.inDays = expireInDays;
expire.inMonths = expireInMonths;
expire.inYears = expireInYears;
function expireAt(date) {
    return expire(() => date <= new Date());
}
function expireIn(time) {
    const expires = new Date();
    expires.setTime(expires.getTime() + time);
    return expireAt(expires);
}
function expireTomorrow() {
    return expireInDays(1);
}
function expireInSeconds(seconds) {
    const expires = new Date();
    expires.setSeconds(expires.getSeconds() + seconds);
    return expireAt(expires);
}
function expireInMinutes(minutes) {
    const expires = new Date();
    expires.setMinutes(expires.getMinutes() + minutes);
    return expireAt(expires);
}
function expireInHours(hours) {
    const expires = new Date();
    expires.setHours(expires.getHours() + hours);
    return expireAt(expires);
}
function expireInDays(days) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    return expireAt(expires);
}
function expireInMonths(months) {
    const expires = new Date();
    expires.setMonth(expires.getMonth() + months);
    return expireAt(expires);
}
function expireInYears(years) {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + years);
    return expireAt(expires);
}
